import type { ConsumerRTHTableTheme } from '../../components/web-only/consumerRTHTable'
import { colors, fonts } from '../dwa-base'

const consumerRTHTableTheme: ConsumerRTHTableTheme = {
  Table: [
    {
      style: {
        border: `1px solid ${String(colors.consumerRTH.border)}`,
        borderCollapse: 'collapse',
      },
    },
  ],
  FirstTableHeaderCell: [
    {
      style: {
        border: `1px solid ${String(colors.consumerRTH.border)}`,
        borderCollapse: 'collapse',
        minWidth: '200px',
      },
    },
  ],
  TableHeaderCell: [
    {
      style: {
        border: `1px solid ${String(colors.consumerRTH.border)}`,
        borderCollapse: 'collapse',
        justifyContent: 'center',
        minWidth: '60px',
        fontFamily: String(fonts.defaultSemibold),
        fontSize: '14px',
        fontWeight: 'bold',
        color: String(colors.consumerRTH.tableHeaderText),
      },
    },
  ],
  FirstColumn: [
    {
      style: {
        border: `1px solid ${String(colors.consumerRTH.border)}`,
        borderCollapse: 'collapse',
        minWidth: '200px',
        padding: '8px',
        textAlign: 'center',
        fontFamily: String(fonts.defaultLight),
        fontSize: '14px',
      },
    },
  ],
  TableRow: [
    {
      style: {
        textAlign: 'center',
        fontFamily: String(fonts.defaultLight),
        fontSize: '14px',
        color: String(colors.consumerRTH.tableText),
      },
    },
  ],
  TableCell: [
    {
      style: {
        border: `1px solid ${String(colors.consumerRTH.border)}`,
        borderCollapse: 'collapse',
        padding: '8px',
      },
    },
  ],
}

export default consumerRTHTableTheme
